import { useState, useEffect, useCallback } from 'react'
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient"
import { LibelleRemise } from '../../../types/PlafondRemise'

interface UseLibellesRemiseReturn {
    libellesRemise: LibelleRemise[]
    loading: boolean
}

const useLibellesRemise = (): UseLibellesRemiseReturn => {
    const backofficeApiClient = new BackOfficeAPIClient()
    const [libellesRemise, setLibellesRemise] = useState<LibelleRemise[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const fetchLibellesRemise = useCallback(async () => {
        try {
            setLoading(true)
            const data = await backofficeApiClient.get<LibelleRemise[]>("/libellesRemise")
            setLibellesRemise(data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchLibellesRemise()
    }, [fetchLibellesRemise])

    return {
        libellesRemise,
        loading
    }
}

export default useLibellesRemise
